import React from 'react'
import { HeaderOnlyLayout } from '../../layouts'
import { Container } from '../../components'
import { Content } from './components'
import styles from './login.module.css'

const Login = ({required}) => {
  return (
    <div className={styles.wrapper}>
      <HeaderOnlyLayout>
        <Container>
          <Content required={required} />
        </Container>
      </HeaderOnlyLayout>
    </div>
  )
}

export { Login }
